import { environment } from "../../../environments/environment";
import * as i0 from "@angular/core";
var FrontendTestSettingsService = /** @class */ (function () {
    function FrontendTestSettingsService() {
        this.isTestMode = environment.frontEndTest;
        this.isResetAllSettings = false;
        this.partnerAdditionInfo = true;
        this.partnerTypeDefault = false;
        this.clientOn = false;
        if (this.isTestModeOn()) {
            console.log('Frontend Test mode is on'.toLocaleUpperCase());
        }
        else {
            console.log('Frontend Test mode is off'.toLocaleUpperCase());
        }
    }
    FrontendTestSettingsService.prototype.isTestModeOn = function () {
        if (this.isTestMode && !this.isResetAllSettings) {
            return true;
        }
        return false;
    };
    FrontendTestSettingsService.prototype.isHideForTesting = function () {
        if (this.isTestModeOn()) {
            return false;
        }
        return true;
    };
    FrontendTestSettingsService.prototype.isClient = function () {
        if (this.isTestModeOn()) {
            return this.isTestModeOn() && this.clientOn;
        }
        return false;
    };
    FrontendTestSettingsService.prototype.isPartnerAdditionInfo = function () {
        if (this.isTestModeOn()) {
            return this.partnerAdditionInfo;
        }
        return false;
    };
    FrontendTestSettingsService.prototype.isPartnerTypeDefault = function () {
        if (this.isTestModeOn()) {
            return this.partnerTypeDefault;
        }
        return false;
    };
    FrontendTestSettingsService.prototype.isPartnerTypeSingle = function () {
        if (this.isTestModeOn()) {
            return !this.partnerTypeDefault;
        }
        return false;
    };
    FrontendTestSettingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FrontendTestSettingsService_Factory() { return new FrontendTestSettingsService(); }, token: FrontendTestSettingsService, providedIn: "root" });
    return FrontendTestSettingsService;
}());
export { FrontendTestSettingsService };
